module.exports = __webpack_public_path__ + "img/ICONO18.9db96b7e.png";